<div class="content">
  <div class="control" *ngIf="!isVtex">
    <p class="label">API Key</p>
    <mat-form-field appearance="fill">
      <input [value]="credentials.apiKey" matInput readonly />
      <button mat-icon-button matSuffix (click)="copyToClipboard('public')">
        <mat-icon>
          <img
            *ngIf="!successApiKeyCopy"
            src="assets/icons/news/copy_violet.svg"
            class="copy-icon"
            alt="copy"
          />
          <img
            *ngIf="successApiKeyCopy"
            src="assets/icons/checked-onboarding.svg"
            class="copy-icon success"
            alt="tick"
          />
        </mat-icon>
      </button>
    </mat-form-field>
  </div>
  <div class="control" *ngIf="!isVtex">
    <p class="label">Webhook secret</p>
    <div class="form-field">
      <mat-form-field appearance="fill">
        <input
          [type]="hideApiSecret ? 'password' : 'text'"
          [value]="credentials.webhookSecret"
          matInput
          readonly
        />
        <button mat-icon-button matSuffix (click)="copyToClipboard('secret')">
          <mat-icon>
            <img
              *ngIf="!successApiSecretCopy"
              src="assets/icons/news/copy_violet.svg"
              class="copy-icon"
              alt="copy"
            />
            <img
              *ngIf="successApiSecretCopy"
              src="assets/icons/checked-onboarding.svg"
              class="copy-icon success"
              alt="tick"
            />
          </mat-icon>
        </button>
      </mat-form-field>
      <button (click)="hideApiSecret = !hideApiSecret" class="btn-td show-password-btn">
        <img src="/assets/icons/news/eye-{{ hideApiSecret ? 'off' : 'on' }}.svg" alt="see" />
      </button>
    </div>
  </div>
  <div class="control" *ngIf="isVtex">
    <p class="label">App Key</p>
    <div class="form-field">
      <mat-form-field appearance="fill">
        <input
          type="text"
          [value]="credentials.integrations.vtex.appKey"
          matInput
          readonly
        />
        <button mat-icon-button matSuffix (click)="copyToClipboard('appKey')">
          <mat-icon>
            <img
              *ngIf="!successAppKeyCopy"
              src="assets/icons/news/copy_violet.svg"
              class="copy-icon"
              alt="copy"
            />
            <img
              *ngIf="successAppKeyCopy"
              src="assets/icons/checked-onboarding.svg"
              class="copy-icon success"
              alt="tick"
            />
          </mat-icon>
        </button>
      </mat-form-field>
    </div>
  </div>
  <div class="control" *ngIf="isVtex">
    <p class="label">App Token</p>
    <div class="form-field">
      <mat-form-field appearance="fill">
        <input
          type="text"
          [value]="credentials.integrations.vtex.appToken"
          matInput
          readonly
        />
        <button mat-icon-button matSuffix (click)="copyToClipboard('appToken')">
          <mat-icon>
            <img
              *ngIf="!successAppTokenCopy"
              src="assets/icons/news/copy_violet.svg"
              class="copy-icon"
              alt="copy"
            />
            <img
              *ngIf="successAppTokenCopy"
              src="assets/icons/checked-onboarding.svg"
              class="copy-icon success"
              alt="tick"
            />
          </mat-icon>
        </button>
      </mat-form-field>
    </div>
  </div>
</div>
